import * as types from "../actions/types/index";
import {setInitialState} from "../util/utility";

const INITIAL_STATE = setInitialState({
  isFetching: false,
  tipSendResponse: null,
  tipDataList: null,
  tipGoalSendResponse: null,
  tipGoalDataList: null,
});

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.TIP_SEND_REQUEST:
    case types.TIP_DATA_REQUEST:
    case types.TIP_GOAL_SEND_REQUEST:
    case types.TIP_GOAL_DATA_REQUEST:

      return {
        ...state,
        isFetching: true,
      };
    case types.TIP_SEND_RECEIVE:

      return {
        ...state,
        isFetching: false,
        tipSendResponse: action.payload,
      };
    case types.TIP_SEND_FAILURE:

      return {
        ...state,
        isFetching: false,
        tipSendResponse: action.payload,
      };
    case types.TIP_SEND_RESET:
      return {
        ...state,
        tipSendResponse: null,
      };
    case types.TIP_DATA_RECEIVE:

      return {
        ...state,
        isFetching: false,
        tipDataList: action.payload,
      };
    case types.TIP_DATA_FAILURE:

      return {
        ...state,
        isFetching: false,
        tipDataList: action.payload,
      };
    case types.TIP_GOAL_SEND_RECEIVE:
      return {
        ...state,
        isFetching: false,
        tipGoalSendResponse: action.payload,
      };
    case types.TIP_GOAL_SEND_FAILURE:

      return {
        ...state,
        isFetching: false,
        tipGoalSendResponse: action.payload,
      };
    case types.TIP_GOAL_SEND_RESET:
      return {
        ...state,
        tipGoalSendResponse: null,
      };
    case types.TIP_GOAL_DATA_RECEIVE:
      case types.TIP_GOAL_DATA_RESET:
      return {
        ...state,
        isFetching: false,
        tipGoalDataList: action.payload,
      };
    case types.TIP_GOAL_DATA_FAILURE:

      return {
        ...state,
        isFetching: false,
        tipGoalDataList: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}
